import React from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { translator } from "../../utils/Translator";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const StockCountDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  docNumbers = [],
  salesmen = [],
  customers = [],
}) => {
  const { authUser } = useSelector(({ auth }) => auth);
  const { translate } = useSelector(({ i18n }) => i18n);

  if (!open) return null;

  const handleConfirm = async () => {
    try {
      const validDocNumbers = docNumbers.filter(
        (docNo) => docNo && String(docNo).trim() !== ""
      );
      if (validDocNumbers.length === 0) {
        alert(
          translator(
            translate.ISA_InvalidDocNumberToDelete,
            "ไม่พบเลขที่เอกสารที่ถูกต้องให้ลบ"
          )
        );
        if (typeof onClose === "function") onClose();
        return;
      }

      const promises = validDocNumbers.map((docNo) => {
        const payload = {
          Company: authUser?.company || "DEFAULT",
          DocNumber: docNo,
          SalesmanCode: authUser?.salesman || authUser?.username || "DEFAULT",
        };
        return axios.post(
          `${process.env.REACT_APP_API_URL}stockcount/DeleteStockCountTransaction`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("x-access-token")}`,
              "Content-Type": "application/json",
            },
          }
        );
      });

      await Promise.all(promises);

      if (typeof onConfirm === "function") {
        onConfirm(validDocNumbers);
      }
    } catch (error) {
      let errorMessage = translator(
        translate.ISA_CannotDeleteDoc,
        "ไม่สามารถลบเอกสารได้"
      );
      if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      alert(
        translator(
          translate.ISA_DeleteDocFailed,
          "ลบเอกสารล้มเหลว"
        ) +
          ": " +
          errorMessage
      );
    } finally {
      if (typeof onClose === "function") onClose();
    }
  };

  

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle disableTypography>
        <Typography variant="h6">
          {translator(
            translate.ISA_StockCountDeleteTitle,
            "ลบข้อมูลใบนับสต็อก"
          )}
        </Typography>
        <IconButton onClick={onClose} style={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>
          {translator(
            translate.ISA_DeleteDocConfirmPrefix,
            "ต้องการลบข้อมูลเอกสารจำนวน"
          )}{" "}
          "{docNumbers.length}"{" "}
          {translator(translate.ISA_Items, "รายการ")}{" "}
          {translator(translate.ISA_ConfirmQuestion, "ใช่ หรือไม่ ?")}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="div">
          <div>
            {translator(translate.ISA_DocNumber, "เลขที่เอกสาร")} :{" "}
            {docNumbers.join(", ")}
          </div>
          <div>
            {translator(translate.ISA_Salesman, "พนักงานขาย")} :{" "}
            {[...new Set(salesmen)].join(", ")}
          </div>
          <div>
            {translator(translate.ISA_Customer, "ลูกค้า")} :{" "}
            {[...new Set(customers)].join(", ")}
          </div>
        </Typography>
        <div style={{ display: "flex", alignItems: "center", marginTop: 16, color: "#d9534f" }}>
          <i
            className="zmdi zmdi-alert-triangle"
            style={{ fontSize: 22, marginRight: 10, color: "#f39c12" }}
          />
          <div>
            <Typography variant="body2" style={{ color: "#d63031", fontWeight: "bold" }}>
              {translator(
                translate.ISA_DeleteWarningTitle,
                "คำเตือน : หากคุณยืนยันลบเอกสารแล้ว"
              )}
            </Typography>
            <Typography variant="caption" style={{ color: "#d63031" }}>
              {translator(
                translate.ISA_DeleteWarningText,
                "ข้อมูลทั้งหมดจะไม่สามารถกู้คืนได้อีก"
              )}
            </Typography>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {translator(translate.ISA_Cancel1, "ยกเลิก")}
        </Button>
        <Button
          onClick={handleConfirm}
          style={{ backgroundColor: "#d9534f", color: "white" }}
        >
          {translator(translate.ISA_Confirm, "ยืนยัน")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StockCountDeleteDialog;
